import Rest from './rest';

const RESOURCE = "editor";

export default {

    list: function (params) {
        return Rest.get(RESOURCE, {params});
    },

    getUser: function (userId) {
        return Rest.get(`${RESOURCE}/${userId}`);
    },

    add: function (data) {
        return Rest.post(`${RESOURCE}`, data);
    },

    update: function (userId, data) {
        return Rest.put(`${RESOURCE}/${userId}`, data);
    },

    remove: function (userId) {
        return Rest.delete(`${RESOURCE}/${userId}`);
    },
};



// WEBPACK FOOTER //
// ./src/services/UserService.js